export const DEFAULT_PAGE_META = {
  title: 'PuiPi - 寵物二手用品交易平台',
  description: 'PuiPi 是專為寵物愛好者打造的二手交易平台。買賣寵物用品，環保又經濟。',
};

export const STATIC_PAGE_META = {
  '/': {
    title: 'PuiPi - 寵物二手用品交易平台 | 為毛孩找到合適好物',
    description: 'PuiPi 是專為寵物愛好者打造的二手交易平台。買賣貓狗飼料、玩具、服飾、籠子等寵物用品，環保又經濟。',
  },
  '/sell': { title: '刊登商品', description: '在 PuiPi 刊登您的寵物用品，讓閒置好物找到新主人。' },
  '/search': { title: '搜尋', description: '搜尋各類寵物二手用品。' },
  '/categories': { title: '商品分類', description: '瀏覽各類寵物用品分類。' },
  '/auctions': { title: '競標', description: '參與寵物用品競標，搶好物。' },
  '/bundles': { title: '組合包', description: '超值寵物用品組合包。' },
  '/services': { title: '寵物服務', description: '尋找各類寵物服務。' },
  '/events': { title: '活動', description: '寵物相關活動資訊。' },
  '/blog': { title: '部落格', description: '寵物飼養知識與分享。' },
  '/forum': { title: '討論區', description: '寵物愛好者交流討論。' },
  '/dog-walking': { title: '幫溜狗專區', description: '找人幫忙遛狗，或幫毛孩散散步交朋友。' },
  '/adoption': { title: '認養專區', description: '給毛孩一個溫暖的家。' },
  '/charity': { title: '公益', description: '寵物公益活動與捐助。' },
  '/lost-found': { title: '協尋', description: '走失寵物協尋資訊。' },
  '/map': { title: '地圖', description: '附近寵物用品與服務地圖。' },
  '/feed': { title: '動態', description: '最新社群動態。' },
  '/about': { title: '關於我們', description: '了解 PuiPi 寵物二手交易平台。' },
  '/contact': { title: '聯絡我們', description: '有任何問題歡迎聯絡我們。' },
  '/faq': { title: '常見問題', description: '常見問題與解答。' },
  '/help': { title: '幫助中心', description: '使用指南與幫助中心。' },
  '/terms': { title: '服務條款', description: 'PuiPi 服務條款。' },
  '/privacy': { title: '隱私權政策', description: 'PuiPi 隱私權政策。' },
  '/insurance': { title: '寵物保險', description: '寵物保險方案介紹。' },
  '/pet-health': { title: '寵物健康', description: '寵物健康資訊與建議。' },
  '/coupons': { title: '優惠券', description: '領取優惠券享折扣。' },
  '/compare': { title: '商品比較', description: '比較不同寵物用品。' },
  '/referral': { title: '推薦好友', description: '推薦好友加入 PuiPi。' },
  '/favorites': { title: '我的收藏', description: '收藏的寵物用品。' },
  '/orders': { title: '我的訂單', description: '查看訂單紀錄。' },
  '/dashboard': { title: '儀表板', description: '個人數據統計。' },
  '/notifications': { title: '通知', description: '最新通知。' },
  '/alerts': { title: '提醒', description: '價格與商品提醒。' },
  '/achievements': { title: '成就', description: '我的成就紀錄。' },
  '/analytics': { title: '分析', description: '銷售數據分析。' },
  '/chat': { title: '聊天', description: '與賣家買家即時聊天。' },
  '/profile': { title: '個人資料', description: '編輯個人資料。' },
  '/settings': { title: '設定', description: '帳號設定。' },
  '/manage-products': { title: '管理商品', description: '管理已刊登商品。' },
  '/returns': { title: '退貨', description: '退貨申請與紀錄。' },
  '/wishlists': { title: '願望清單', description: '我的願望清單。' },
  '/verification': { title: '身份驗證', description: '帳號身份驗證。' },
  '/verify-email': { title: '驗證信箱', description: '信箱驗證。' },
  '/admin': { title: '管理後台', description: '系統管理。' },
  '/store/customize': { title: '自訂商店', description: '自訂您的商店頁面。' },
};

const DYNAMIC_PAGE_META = [
  {
    pattern: /^\/product\/[^/]+$/,
    meta: { title: '商品詳情', description: '查看商品詳情、價格、商品狀態與賣家資訊。' },
  },
  {
    pattern: /^\/blog\/[^/]+$/,
    meta: { title: '文章', description: '閱讀 PuiPi 的寵物飼養知識與分享文章。' },
  },
  {
    pattern: /^\/auction\/[^/]+$/,
    meta: { title: '競標詳情', description: '查看競標商品資訊、目前出價與結標時間。' },
  },
  {
    pattern: /^\/bundle\/[^/]+$/,
    meta: { title: '組合包詳情', description: '查看組合包內容、價格與賣家資訊。' },
  },
  {
    pattern: /^\/event\/[^/]+$/,
    meta: { title: '活動詳情', description: '查看活動時間、地點與報名資訊。' },
  },
  {
    pattern: /^\/service\/[^/]+$/,
    meta: { title: '服務詳情', description: '查看寵物服務介紹、地點與聯絡資訊。' },
  },
  {
    pattern: /^\/store\/[^/]+$/,
    meta: { title: '商店', description: '查看商店介紹、上架商品與賣家資訊。' },
  },
  {
    pattern: /^\/user\/[^/]+$/,
    meta: { title: '用戶資料', description: '查看用戶資料、商品與交易評價。' },
  },
  {
    pattern: /^\/wishlist\/share\/[^/]+$/,
    meta: { title: '分享願望清單', description: '查看分享的願望清單與想要的寵物用品。' },
  },
  {
    pattern: /^\/wishlist\/[^/]+$/,
    meta: { title: '願望清單', description: '查看願望清單內容與想要的寵物用品。' },
  },
];

export function getPageMeta(pathname = '/') {
  const staticMeta = STATIC_PAGE_META[pathname];
  if (staticMeta) {
    return staticMeta;
  }

  const dynamicMeta = DYNAMIC_PAGE_META.find(({ pattern }) => pattern.test(pathname));
  return dynamicMeta?.meta || DEFAULT_PAGE_META;
}

export function formatDocumentTitle(title) {
  if (!title) {
    return 'PuiPi';
  }

  return title.includes('PuiPi') ? title : `${title} | PuiPi`;
}
